import React from "react";
import Dropdown from "react-bootstrap/Dropdown";

import T, { GetLang } from "@components/translations/Translations";

// ─── Module-level helpers ─────────────────────────────────────────────────────

/**
 * The forwardRef is important!!
 * Dropdown needs access to the DOM node in order to position the Menu
 */
const HelpfulToggle = React.forwardRef<HTMLButtonElement, { onClick?: React.MouseEventHandler }>(({ onClick }, ref) => {
    const lang = GetLang();
    return (
        <button
            aria-label="Helpful Links Button"
            className="btn btn-primary m-2 color-override"
            onClick={(e) => {
                e.preventDefault();
                onClick?.(e);
            }}
            ref={ref}
            type="button"
        >
            <span className="nav-button-text" style={{ whiteSpace: "nowrap" }}>
                {T({ tKey: "Main_Nav_HelpfulLinks", langStr: lang })}
                <i className="bi bi-info-square" style={{ fontSize: "0.9rem", fontWeight: 700, marginLeft: "10px" }} />
            </span>
        </button>
    );
});
HelpfulToggle.displayName = "HelpfulToggle";

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * A dropdown menu displaying resource links for the guardian
 * @name HelpfulLinks
 * @returns {JSX.Element}
 */
const HelpfulLinks = (): JSX.Element => {
    const lang = GetLang();
    return (
        <Dropdown align="end">
            <Dropdown.Toggle as={HelpfulToggle} id="dropdown-custom-components">
                <b>{T({ tKey: "Main_Nav_LogOut", langStr: lang })}</b>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item href="https://www.dcsdk12.org/schools-academics/academic-calendars" target="_blank">
                    {/* Academic Calendars */}
                    <i className="bi bi-calendar2-week" /> {T({ tKey: "Main_Nav_HelpfulLinks_LI_s2", langStr: lang })}
                </Dropdown.Item>
                <Dropdown.Item href="https://dcsd.nutrislice.com/menus-eula" target="_blank">
                    {/* Lunch Menus */}
                    <i className="bi bi-apple" /> {T({ tKey: "Main_Nav_HelpfulLinks_LI_s6", langStr: lang })}
                </Dropdown.Item>
                <Dropdown.Item href="https://www.myschoolbucks.com/ver2/getmain?requestAction=home" target="_blank">
                    {/* Online Payments */}
                    <i className="bi bi-coin" /> {T({ tKey: "Main_Nav_HelpfulLinks_LI_s5", langStr: lang })}
                </Dropdown.Item>
                <Dropdown.Item href="https://www.dcsdk12.org/parents-students/resources" target="_blank">
                    {/* Parent Resources */}
                    <i className="bi bi-journals" /> {T({ tKey: "Main_Nav_HelpfulLinks_LI_s3", langStr: lang })}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default HelpfulLinks;
